const getters = {
  sidebar: (state) => state.app.deviceWidth,
  isUserEditDialog: (state) => state.app.isUserEditDialog,
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  avatar: (state) => state.user.userInfo.avatar,
  userId: (state) => state.user.userInfo?.uid,
  isNewUser: (state) => state.user?.isNewUser,
  TAL_ID: (state) => state.user.userInfo?.talId,
  orgList: (state) => state.user.userInfo?.orgList,
  org: (state) => state.user.org,
  headerLoginJump: (state) => state.user.headerLoginJump,
  abTestInfo: (state) => state.app.abTestInfo,
  isFrom: (state) => state.app.isFrom,
  isAICreating: (state) => state.app.isAICreating,
};
export default getters;
